import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, createSlots as _createSlots } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新增发票")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 境内导入 ")
const _hoisted_4 = {
  key: 0,
  style: {"padding":"0px 12px"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "请先填写筛选条件", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("批量下载发票")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_we_table = _resolveComponent("we-table")!
  const _component_page_wrapper = _resolveComponent("page-wrapper")!
  const _directive_active = _resolveDirective("active")!

  return (_openBlock(), _createBlock(_component_page_wrapper, {
    title: _ctx.pageConfig.title
  }, {
    default: _withCtx(() => [
      _createVNode(_component_we_table, { onRegister: _ctx.register }, {
        name: _withCtx(({ text, record }) => [
          _withDirectives(_createVNode(_component_a_button, {
            type: "link",
            onClick: ($event: any) => (_ctx.jumpToInvoice(record.id, true))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(text), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]), [
            [_directive_active]
          ])
        ]),
        rd_state_name: _withCtx(({ text, record }) => [
          _createElementVNode("span", {
            style: _normalizeStyle({ color: record.rd_state_color })
          }, _toDisplayString(text), 5)
        ]),
        company__name: _withCtx(({ text, record }) => [
          _createVNode(_component_a_button, {
            type: "link",
            onClick: ($event: any) => (_ctx.jumpToCompany(record.company_id))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(text), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        linked_amount: _withCtx(({ text, record }) => [
          (record.linked_amount)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "link",
                onClick: ($event: any) => (_ctx.showBills(record.id))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.switchNumber(text, 2)), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(text), 1))
        ]),
        unlinked_amount: _withCtx(({ record }) => [
          _createElementVNode("span", null, _toDisplayString(_ctx.switchNumber(record.it_amount - record.linked_amount, 2)), 1)
        ]),
        tax_rate: _withCtx(({ text }) => [
          _createElementVNode("span", null, _toDisplayString(text) + "%", 1)
        ]),
        date: _withCtx(({ text }) => [
          _createElementVNode("span", null, _toDisplayString(_ctx.formatTime(text, 'YYYY-MM-DD')), 1)
        ]),
        headerButton: _withCtx(() => [
          _createVNode(_component_a_select, {
            value: _ctx.filterType,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterType) = $event)),
            options: _ctx.dateRangeOptions,
            onChange: _ctx.reload,
            style: {"width":"240px !important"}
          }, null, 8, ["value", "options", "onChange"]),
          _withDirectives(_createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.addInvoice
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"]), [
            [_vShow, _ctx.canAddInvoice]
          ]),
          _withDirectives(_createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.importExcel
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"]), [
            [_vShow, _ctx.hasPermission('CanImportCNInvoiceData')]
          ]),
          (!_ctx.hasPermission('RoleFinanceDataViewer') || _ctx.isGod)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (!_ctx.isPurchase)
                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 0,
                      placement: "bottom"
                    }, _createSlots({
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          disabled: !_ctx.screenOut,
                          onClick: _ctx.downloadInvoiceFile
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"])
                      ]),
                      _: 2
                    }, [
                      (!_ctx.screenOut)
                        ? {
                            name: "title",
                            fn: _withCtx(() => [
                              _hoisted_5
                            ])
                          }
                        : undefined
                    ]), 1024))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onRegister"])
    ]),
    _: 1
  }, 8, ["title"]))
}